import { AppstoreAddOutlined } from "@ant-design/icons";
import { Modal, Input, Form, Button, Switch } from "antd";
import { ButtonActiveModal } from "../../../components/Buttons/ButtonActiveModal";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { usePagePlatformsData } from "./hooks/usePagePlatformsData";

const { Search } = Input;

export const PagePlatforms = () => {
    const {
        searchValue,
        activeModal,
        typeModal,
        loadingButton,
        form,
        isLoading,
        handleOpenModalCreate,
        handleOnCancel,
        onFinish,
        tableFilterDataPlatforms,
        handleChange,
        columns,
        tableProps,
        pagination,
    } = usePagePlatformsData();



    return (
        <div className="lg:p-12 p-4 w-full h-full flex flex-col gap-6">
            <CardDetailProject
                title="Plataformas"
                headerChildren={
                    <>
                        <ButtonActiveModal
                            icon={<AppstoreAddOutlined />}
                            action={handleOpenModalCreate}
                            className="bg-primaryTwo hover:bg-primaryTwoHover px-6 py-2 flex justify-center items-center lg:ml-auto"
                            size={{ w: 144, h: 32 }}
                            title="Crear plataforma"
                        />

                        <Search
                            placeholder="Búsqueda por plataforma"
                            onChange={handleChange}
                            value={searchValue}
                            className="w-full md:max-w-64 order-last sm:mt-2 md:mt-0"
                        />
                    </>
                }
            >
                <div className="w-full max-w-[480px] flex justify-center mx-auto">
                    <TableGeneral
                        column={columns}
                        loading={isLoading}
                        state={tableFilterDataPlatforms}
                        pagination={pagination}
                        tableProps={tableProps}
                    />
                </div>
            </CardDetailProject>
            <Modal
                title={`${typeModal === 0 ? "Crear platadforma" : "Editar platadforma"}`}
                width={400}
                onCancel={handleOnCancel}
                open={activeModal}
                footer={[]}
            >
                <Form form={form} name="platform_project" layout="vertical" style={{ width: "100%" }} onFinish={onFinish}>
                    {typeModal === 0 && (
                        <div className="flex items-center justify-start gap-4">
                            <Form.Item name="isActive" label="¿Esta activo?" valuePropName="checked" className="flex h-6 relative top-3">
                                <Switch className="ml-4 relative bottom-[6px]" />
                            </Form.Item>
                        </div>
                    )}
                    <Form.Item
                        name="name"
                        label="Nombre"
                        rules={[
                            {
                                required: true,
                                message: "Nombre",
                                whitespace: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item className="w-full flex justify-end m-0 mt-4">
                        <Button type="primary" htmlType="submit" loading={loadingButton}>
                            {typeModal === 0 ? "Crear" : "Editar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
